'use client';

import { useEffect, useState } from 'react';

type Args = {
  galleryId: string;
};

export const useGallery = (args: Args) => {
  const { galleryId } = args;

  const [enabledGalleryId, setEnabledGalleryId] = useState(() => {
    if (typeof window !== 'undefined') {
      const queryParams = new URLSearchParams(window.location.search);
      return queryParams.get('g');
    }
  });

  const handleOpenGallery = (slide: number) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('g', galleryId);
    queryParams.set('slide', (slide + 1).toString());
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    setEnabledGalleryId(galleryId);
  };

  const handleCloseGallery = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const newUrl = new URL(window.location.href);
    queryParams?.delete('g');
    queryParams?.delete('slide');
    newUrl.search = queryParams.toString();
    window.history.pushState({ path: newUrl.toString() }, '', newUrl.toString());
    setEnabledGalleryId(null);
  };

  useEffect(() => {
    const beforePopStateEvent = () => {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('g') === null) {
        setEnabledGalleryId(null);
      }
    };
    window.addEventListener('popstate', beforePopStateEvent);
    return () => window.removeEventListener('popstate', beforePopStateEvent);
  }, []);

  return {
    isGalleryOpen: enabledGalleryId === galleryId,
    handleOpenGallery,
    handleCloseGallery,
  };
};
